import React from 'react'
import { Modal } from 'ui/Modal'
import successPage from '../../../assets/images/Paymen_Success_Icon.png'
import styled from 'styled-components'
import moment from 'moment'
import NumberFormat from 'react-number-format'

const StyledSuccessDiv = styled.div`
    text-align: center;
    display: flex;
    align-items: center;
    flex-direction: column;`
const StyleDetailsDiv =styled.div`
  
    box-shadow: rgb(17 17 33 / 20%) 0px 7px 29px 0px;
    border-radius: 10px;
    margin: 20px;
    min-width: 400px;`
const RefundSuccessModal = ({data,show,hide}) => {
    
  return (
    <Modal
    show={show}
    onHide={()=>hide()}
    centered
    >
        <StyledSuccessDiv>
            <img src={successPage} alt="" />
            <h1 style={{fontSize: '24px', fontFamily: 'Montserrat Alternates-Bold', color: '#909090'}}>Refund Initiated!</h1>

            <StyleDetailsDiv>
            <div
              style={{
                color: "grey",
                paddingTop: "10px",
                display: "grid",
                justifyContent:"center",
                alignItems:"center",
      
                padding: "20px",
              }}
            >
              <table style={{marginBottom:"20px",width: '350px'}}>
              
         
                <tr>
                  <td style={{ fontWeight: "600", textAlign: "left",fontSize:"14px" }}>
                    Transaction ID
                  </td>
                  <td
                    style={{
                      textAlign: "end",
                      color: "#909090",
                      fontWeight: "600",
                      fontSize:"14px"
                    }}
                  >
                    {data.transactionId}
                  </td>
                </tr>
                <tr>
                  <td style={{ fontWeight: "600", textAlign: "left",fontSize:"14px" }}>
                  Transaction Date
                  </td>
                  <td
                    style={{
                      textAlign: "end",
                      color: "#909090",
                      fontWeight: "600",
                      fontSize:"14px"
                    }}
                  >
                  {moment(data.TransactionTimeStamp).format("MM/DD/YYYY")}
                  </td>
                </tr>
                <tr>
                <td style={{ fontWeight: "600", textAlign: "left",fontSize:"14px" }}>
                 Amount
                  </td>
                  <td
                    style={{
                      textAlign: "end",
                      color: "#909090",
                      fontWeight: "600",
                      fontSize:"14px"
                    }}
                  >
                   <NumberFormat
                   thousandSeparator={true}
                   prefix={"$"}
                   value={parseFloat(data.invoiceAmount)}
                   displayType="text"
                   isNumericString={true}
                   decimalScale={2}
                 />
                  </td>
                </tr>
                <tr>
                <td style={{ fontWeight: "600", textAlign: "left",fontSize:"14px" }}>
                 Status
                  </td>
                  <td
                    style={{
                      textAlign: "end",
                      color: "#909090",
                      fontWeight: "600",
                      fontSize:"14px"
                    }}
                  >
              {data.transactionDetails[0].transactionStatus}
                  </td>
                </tr>
              </table>
             
{/* 
              <p style={{ textAlign: "center", marginTop: "15px",fontSize:"12px" }}>
              Copyright &copy;{new Date().getFullYear()} SimpliCapital. All rights Reserved{" "}
              </p> */}
            </div>
            </StyleDetailsDiv>
        </StyledSuccessDiv>

    </Modal>
  )
}

export default RefundSuccessModal